import { PrintCardMenu } from './print-card-menu';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { AssetLibraryType } from '../../enum/dto/asset-library-type.enum';

export class MasterKushStrainPrintCardMenu extends PrintCardMenu {
  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.Roboto.Medium_500, FONT.Roboto.SemiBold_600, FONT.Roboto.Bold_700, FONT.Roboto.Black_900];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/uyh7yqc.css';
  }

  shouldFetchVariantAssets(): boolean {
    return true;
  }

  variantAssetTypeSortOrder(): string[] {
    return [AssetLibraryType.PrimaryBrand, AssetLibraryType.AlternateBrand, AssetLibraryType.Brand];
  }
}
